export const maskPhoneNumber = (phoneNumber: string): string => {
  const splitted = phoneNumber.split(" ");

  if (splitted.length !== 3) {
    return phoneNumber;
  }

  return `********${splitted[2]}`;
};
